module.exports = __webpack_public_path__ + "img/forecast-img1.c56a0ad6.png";